
/*!
* Copyright (c) Microsoft Corporation.
* All rights reserved. See LICENSE in the project root for license information.
* THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
* TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
*/
import {
  //AsyncResult,
  retailAction,
  //callActionOrExecute,
  DataServiceQuery,
  IContext,
  IDataServiceRequest,
  IQueryResultSettings,
  // @ts-ignore -- Unused import
  NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
//import {OrderInvoice} from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

//***************************************
function tmcGetAchHashQuery(): DataServiceQuery {
  return new DataServiceQuery();
}
export function tmcGetAchHashInput(
  paymentData:
    string
): IDataServiceRequest {
  const query = tmcGetAchHashQuery();
  return query.createDataServiceRequestForOperation(
    'TMCGetAchHash',
    true,
    '',
    'false',
    { bypassCache: 'get', returnEntity: '' },
    {
      paymentData: paymentData
    }
  );
}

export function tmcGetAchHashAsync(
  context: IContext, paymentData:
    string
): Promise<string> {
  const request = tmcGetAchHashInput(paymentData);
  return retailAction<string>(request, context.callerContext);
}

//***************************************
function tmcAchPostbackQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function tmcAchPostbackInput(
  paymentData:
    string
): IDataServiceRequest {
  const query = tmcAchPostbackQuery();
  return query.createDataServiceRequestForOperation(
    'TMCAchPostback',
    true,
    ''
    ,
    'false',
    { bypassCache: 'get', returnEntity: '' },
    {
      paymentData: paymentData
    }
  );
}

export function tmcAchPostbackAsync(
  context: IContext, paymentData:
    string
): Promise<string> {
  const request = tmcAchPostbackInput(paymentData);
  return retailAction<string>(request, context.callerContext);
}

//***************************************
function tmcAchCheckPostbackQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function tmcAchCheckPostbackInput(
  paymentData:
    string
): IDataServiceRequest {
  const query = tmcAchCheckPostbackQuery();
  return query.createDataServiceRequestForOperation(
    'TMCAchCheckPostback',
    true,
    ''
    ,
    'false',
    { bypassCache: 'get', returnEntity: '' },
    {
      paymentData: paymentData
    }
  );
}

export function tmcAchCheckPostbackAsync(
  context: IContext, paymentData:
    string
): Promise<string> {
  const request = tmcAchCheckPostbackInput(paymentData);
  return retailAction<string>(request, context.callerContext);
}

//***************************************
function tmcAchGetTransDataQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function tmcAchGetTransDataInput(
  queryData:
    string
): IDataServiceRequest {
  const query = tmcAchGetTransDataQuery();
  return query.createDataServiceRequestForOperation(
    'TMCAchGetTransData',
    true,
    ''
    ,
    'false',
    { bypassCache: 'get', returnEntity: '' },
    {
      queryData: queryData
    }
  );
}

export function tmcAchGetTransDataAsync(
  context: IContext, queryData:
    string
): Promise<string> {

  if (!context.callerContext.requestContext.user.isAuthenticated) {
      return Promise.resolve('');
  }
  const request = tmcAchGetTransDataInput(queryData);
  return retailAction<string>(request, context.callerContext);
}

//***************************************
function tmcAchReportQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function tmcAchReportInput(
  reportData:
    string
): IDataServiceRequest {
  const query = tmcAchReportQuery();
  return query.createDataServiceRequestForOperation(
    'TMCAchReport',
    true,
    ''
    ,
    'false',
    { bypassCache: 'get', returnEntity: '' },
    {
      reportData: reportData
    }
  );
}

export function tmcAchReportAsync(
  context: IContext, reportData:
    string
): Promise<string> {
  const request = tmcAchReportInput(reportData);
  return retailAction<string>(request, context.callerContext);
}

function tmcGetInvoicesQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

//***************************************
export function tmcGetInvoicesInput(
  queryResultSettings: IQueryResultSettings, searchCriteria:
    Entities.InvoiceSearchCriteria
): IDataServiceRequest {
  const query = tmcGetInvoicesQuery().resultSettings(queryResultSettings);
  return query.createDataServiceRequestForOperation(
    'TMCGetInvoices',
    true, EntityClasses.OrderInvoiceClass,//.OrderInvoice,
    'true',
    { bypassCache: 'get', returnEntity: 'Entities.OrderInvoice' },
    {
      searchCriteria: searchCriteria
    }
  );
}

export function tmcGetInvoicesAsync(
  context: IContext, searchCriteria:
    Entities.InvoiceSearchCriteria
): Promise<Entities.OrderInvoice[]> {
  const request = tmcGetInvoicesInput(
    context.queryResultSettings || {}, searchCriteria);
  return retailAction<Entities.OrderInvoice[]>(request, context.callerContext);
}

//***************************************/
function tmcAchSetClearedQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function tmcAchSetClearedInput(
  clearedData:
    string
): IDataServiceRequest {
  const query = tmcAchSetClearedQuery();
  return query.createDataServiceRequestForOperation(
    'TMCAchSetCleared',
    true,
    ''
    ,
    'false',
    { bypassCache: 'get', returnEntity: '' },
    {
      clearedData: clearedData
    }
  );
}

export function tmcAchSetClearedAsync(
  context: IContext, clearedData:
    string
): Promise<string> {
  const request = tmcAchSetClearedInput(clearedData);
  return retailAction<string>(request, context.callerContext);
  //return callActionOrExecute<string>(request, context.callerContext);
}

//***************************************
function tmcGetCustomerBalanceQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function tmcGetCustomerBalanceInput(
  accountNumber:
    string,
  invoiceAccountNumber:
    string
): IDataServiceRequest {
  const query = tmcGetCustomerBalanceQuery();
  return query.createDataServiceRequestForOperation(
    'TMCGetCustomerBalance',
    true,
    DataServiceEntities.GetCustomerBalanceExResponseExtensionClass
    ,
    'false',
    { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetCustomerBalanceExResponse' },
    {
      accountNumber: accountNumber,
      invoiceAccountNumber: invoiceAccountNumber
    }
  );
}

export function tmcGetCustomerBalanceAsync(
  context: IContext, accountNumber:
    string,
  invoiceAccountNumber:
    string
): Promise<DataServiceEntities.IGetCustomerBalanceExResponse> {
  const request = tmcGetCustomerBalanceInput(accountNumber, invoiceAccountNumber);
  return retailAction<DataServiceEntities.IGetCustomerBalanceExResponse>(request, context.callerContext);
}

//******************************************************************* */
function tmcProcessHQFormsQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function tmcProcessHQFormsInput(
  storeNum:
    string,
  documentId:
    string,
  packslipId:
    string,
  invoiceId:
    string,
  invoiceDate:
    string,
  formType:
    string,
  emailAdr:
    string,
  sharepointPath:
    string,
  outputChoice:
    string
): IDataServiceRequest {
  const query = tmcProcessHQFormsQuery();
  return query.createDataServiceRequestForOperation(
    'TMCProcessHQForms',
    true,
    ''
    ,
    'false',
    { bypassCache: 'get', returnEntity: '' },
    {
      StoreNum: storeNum,
      DocumentId: documentId,
      PackslipId: packslipId,
      InvoiceId: invoiceId,
      InvoiceDate: invoiceDate,
      FormType: formType,
      EmailAdr: emailAdr,
      SharepointPath: sharepointPath,
      OutputChoice: outputChoice
    }
  );
}

export function tmcProcessHQFormsAsync(
  context: IContext, storeNum:
    string,
  documentId:
    string,
  packslipId:
    string,
  invoiceId:
    string,
  invoiceDate:
    string,
  formType:
    string,
  emailAdr:
    string,
  sharepointPath:
    string,
  outputChoice:
    string
): Promise<string> {
  const request = tmcProcessHQFormsInput(storeNum, documentId, packslipId, invoiceId, invoiceDate, formType, emailAdr, sharepointPath, outputChoice);
  return retailAction<string>(request, context.callerContext);
}

//******************************************************************* */
function tmcGetSearchSuggestionsQuery(): DataServiceQuery {
  return new DataServiceQuery();
}

export function tmcGetSearchSuggestionsInput(
  queryResultSettings: IQueryResultSettings, searchSuggestionCriteria:
    Entities.SearchSuggestionCriteria
): IDataServiceRequest {
  const query = tmcGetSearchSuggestionsQuery().resultSettings(queryResultSettings);
  return query.createDataServiceRequestForOperation(
    'TMCGetSearchSuggestions',
    true, EntityClasses.SearchSuggestionClass,
    'true',
    { bypassCache: 'get', returnEntity: 'Entities.SearchSuggestion' },
    {
      searchSuggestionCriteria: searchSuggestionCriteria
    }
  );
}

export function tmcGetSearchSuggestionsAsync(
  context: IContext, searchSuggestionCriteria:
    Entities.SearchSuggestionCriteria
): Promise<Entities.SearchSuggestion[]> {
  const request = tmcGetSearchSuggestionsInput(
    context.queryResultSettings || {}, searchSuggestionCriteria);
  return retailAction<Entities.SearchSuggestion[]>(request, context.callerContext);
}

